// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__DqjNT","title":"styles_title__SUY6k","description":"styles_description__xB8-v"};